module.exports = __webpack_public_path__ + "img/portrait-042.22f57867.jpg";